/**
 * LAB-4507 — shared "download OpenAPI YAML" util.
 *
 * Extracted from `SitemapTab.handleDownloadOpenAPI` (SitemapTab.tsx:189-203),
 * parameterized so the Sitemap and Endpoints sub-tabs share one implementation
 * (same MIME + filename convention, no drift).
 */
export function downloadOpenApiYaml(yaml: string, hostname: string): void {
  const blob = new Blob([yaml], {
    type: 'application/yaml;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${hostname || 'web-application'}-openapi.yaml`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
